(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealSelector = [
    '.lc-shop-hub__intro',
    '.lc-shop-hub__group',
    '.product-grid .grid__item',
    '.collection-list .grid__item',
    '.multicolumn-list__item',
    '.rich-text__wrapper',
    '.lc-live-whatnot',
    '.lc-collector-gallery',
    '.lc-collection-strip',
    '.lc-pokemon30',
    '.image-with-text__media-item',
    '.image-with-text__text-item'
  ].join(',');

  let observer;

  const revealImmediately = (elements) => {
    elements.forEach((element) => element.classList.add('is-visible'));
  };

  const setupReveal = () => {
    const elements = Array.from(document.querySelectorAll(revealSelector)).filter(
      (element) => !element.hasAttribute('data-lc-motion')
    );

    if (!elements.length) return;

    elements.forEach((element, index) => {
      element.setAttribute('data-lc-motion', '');
      element.classList.add('lc-motion-reveal');
      element.style.setProperty('--lc-stagger', Math.min(index % 6, 5) * 45 + 'ms');
    });

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      revealImmediately(elements);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -7% 0px', threshold: 0.08 }
      );
    }

    elements.forEach((element) => observer.observe(element));
  };

  const isExcludedNavigation = (destination) => {
    if (!destination) return true;

    const url = new URL(destination, window.location.href);

    if (url.origin !== window.location.origin) return true;

    return ['/checkout', '/account', '/cart'].some(
      (path) => url.pathname === path || url.pathname.startsWith(path + '/')
    );
  };

  const cancelOnInteraction = (event) => {
    const transition = event.viewTransition;
    if (!transition) return;

    ['pointerdown', 'keydown'].forEach((eventType) => {
      document.addEventListener(
        eventType,
        () => transition.skipTransition(),
        { once: true }
      );
    });
  };

  if (!reducedMotion.matches) {
    document.documentElement.classList.add('lc-motion-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReveal, { once: true });
  } else {
    setupReveal();
  }

  document.addEventListener('shopify:section:load', setupReveal);

  window.addEventListener('pageswap', (event) => {
    if (!event.viewTransition) return;

    const destination = event.activation?.entry?.url;

    if (reducedMotion.matches || isExcludedNavigation(destination)) {
      event.viewTransition.skipTransition();
      return;
    }

    cancelOnInteraction(event);
  });

  window.addEventListener('pagereveal', (event) => {
    if (!event.viewTransition) return;

    if (reducedMotion.matches) {
      event.viewTransition.skipTransition();
      return;
    }

    cancelOnInteraction(event);
  });
})();